import { Typography } from "@mui/material";
import React, { useRef } from "react";
import "../tug/testModuleInfoPage.scss";
import infoIcon from "../../../../assets/images/info.svg";
import forwardArrow from "../../../../assets/images/forwardArrow.svg";
import viewReport from "../../../../assets/images/viewReport.svg";
import uploadVideo from "../../../../assets/images/uploadVideo.svg";
import locomotiveImg from "../../../../assets/images/locomotive.svg";
import { useDispatch } from "react-redux";
import { uploadData } from "aws-amplify/storage";
import { setAPILoader } from "../../../../state/actions/globalAction";
import UserDetailsHeader from "../../UserDetailsHeader";
import { userInfoFetch } from "../../../../utlis/commonFunction";
import { getParams } from "../../../../utlis/helpers";

const LocoMotive = () => {
  const videoRef = useRef();
  const dispatch = useDispatch();
  const storedTest = JSON.parse(sessionStorage.getItem("testMModule"));
  const getTestDetails = storedTest.find((e) => e.moduleId === 3);
  const itemList = [
    {
      icon: infoIcon,
      title: "How to test?",
    },
    {
      icon: viewReport,
      title: "View Report",
    },
    {
      icon: uploadVideo,
      title: "Upload video",
    },
  ];
  const { accessToken } = getParams();
  const videoHandler = (index) => {
    if (index === 1) {
      window.location.href = `${getTestDetails?.reportURL}&accessToken=${accessToken}`;
    }
    if (index === 2) {
      videoRef.current.click();
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      dispatch(setAPILoader(true));
      const date = new Date().getTime();
      const fileName = date + "/" + "test_video.mp4";
      try {
        const result = await uploadData({
          key: `${userInfoFetch()?.id}/locomo/` + fileName,
          data: file,
          options: {
            accessLevel: "guest",
          },
        }).result;
        dispatch(setAPILoader(false));
        event.target.value = "";
        console.log("Succeeded: ", result);
      } catch (error) {
        dispatch(setAPILoader(false));
        event.target.value = "";
        console.log("Error : ", error);
      }
    }
  };

  return (
    <UserDetailsHeader>
      <div className="tug-test-info-wrapper">
        <Typography className="title">Locomotive Syndrome</Typography>
        <div className="tug-module-box">
          <div className="tug-module-subbox">
            <img
              src={locomotiveImg}
              alt="tug-side"
              className="test-img side-img"
            />
            <Typography className="test-description">
              Tests level of strength and balance in standing up and walking
            </Typography>
            {itemList.map((item, index) => {
              return (
                <div
                  className="item-wrapper"
                  key={index}
                  onClick={() => videoHandler(index)}
                >
                  <div className="item-name">
                    <img src={item.icon} alt="info" className="img" />
                    <Typography>{item.title}</Typography>
                  </div>
                  <div className="arrow">
                    <img src={forwardArrow} alt="forwardArrow" />
                  </div>
                </div>
              );
            })}
            <input
              type="file"
              accept="video/mp4"
              ref={videoRef}
              className="video-upload"
              onChange={handleFileChange}
            />
          </div>
        </div>
      </div>
    </UserDetailsHeader>
  );
};

export default LocoMotive;
